import { Check, ChevronDown, LayoutGrid, Search, X } from "lucide-react";
import { useState } from "react";
import { buildBrandTiles } from "../data/brands";

function countLabel(count) {
  return count === 1 ? "1 Fahrzeug" : `${count} Fahrzeuge`;
}

function BrandTile({ brand, active, onSelect }) {
  return (
    <button type="button" className={`brand-tile ${active ? "is-active" : ""} ${brand.count === 0 ? "is-empty" : ""}`} aria-pressed={active} onClick={() => onSelect(active ? "" : brand.slug)} data-testid={`brand-tile-${brand.slug}`}>
      <span className="brand-tile-name">{brand.name}</span>
      <span className="brand-tile-logo" aria-hidden="true">{brand.logo ? <img src={brand.logo} alt="" loading="lazy" /> : <span className="brand-tile-initial">{brand.name.slice(0, 1)}</span>}</span>
      <span className="brand-tile-count" data-testid={`brand-count-${brand.slug}`}>{countLabel(brand.count)}</span>
      {active && <span className="brand-tile-check" aria-hidden="true"><Check size={13} strokeWidth={2.5} /></span>}
    </button>
  );
}

export default function BrandSearch({ inventory, brandContext, brand, onBrandChange, query, onQueryChange }) {
  const [showEmptyBrands, setShowEmptyBrands] = useState(false);
  const totals = new Map(buildBrandTiles(inventory).map((tile) => [tile.slug, tile.count]));
  const tiles = buildBrandTiles(inventory, brandContext);
  // Brands that exist in the dealer stock stay in the main grid (count reflects the other active filters)
  const withVehicles = tiles.filter((tile) => totals.get(tile.slug) > 0 || tile.slug === brand);
  const withoutVehicles = tiles.filter((tile) => !totals.get(tile.slug) && tile.slug !== brand);

  return (
    <div className="brand-search" data-testid="brand-search">
      <label className="search-bar" htmlFor="vehicle-search">
        <Search size={20} strokeWidth={1.6} />
        <input id="vehicle-search" type="search" value={query} onChange={(event) => onQueryChange(event.target.value)} placeholder="z. B. BMW 320, Golf, C-Klasse …" autoComplete="off" aria-label="Marke, Modell oder Fahrzeug suchen" data-testid="vehicle-search-input" />
        {query && <button type="button" className="search-clear" onClick={() => onQueryChange("")} aria-label="Suche löschen" data-testid="vehicle-search-clear-button"><X size={16} /></button>}
      </label>
      <div className="brand-section-head"><h3>Nach Marke suchen</h3><span>Marke antippen – die Liste springt direkt zu den Treffern</span></div>
      <div className="brand-grid" role="group" aria-label="Marken">
        <button type="button" className={`brand-tile brand-tile-all ${!brand ? "is-active" : ""}`} aria-pressed={!brand} onClick={() => onBrandChange("")} data-testid="brand-tile-all">
          <span className="brand-tile-name">Alle Marken</span>
          <span className="brand-tile-logo" aria-hidden="true"><LayoutGrid size={30} strokeWidth={1.3} /></span>
          <span className="brand-tile-count" data-testid="brand-count-all">{countLabel(brandContext.length)}</span>
          {!brand && <span className="brand-tile-check" aria-hidden="true"><Check size={13} strokeWidth={2.5} /></span>}
        </button>
        {withVehicles.map((tile) => <BrandTile key={tile.slug} brand={tile} active={brand === tile.slug} onSelect={onBrandChange} />)}
      </div>
      {withoutVehicles.length > 0 && <>
        <button type="button" className={`brand-more-toggle ${showEmptyBrands ? "is-open" : ""}`} onClick={() => setShowEmptyBrands((current) => !current)} aria-expanded={showEmptyBrands} data-testid="brand-more-toggle">
          <span>Weitere Marken · aktuell nicht im Bestand ({withoutVehicles.length})</span><ChevronDown size={16} />
        </button>
        {showEmptyBrands && <div className="brand-grid brand-grid-muted" role="group" aria-label="Marken ohne Fahrzeuge" data-testid="brand-grid-muted">
          {withoutVehicles.map((tile) => <BrandTile key={tile.slug} brand={tile} active={brand === tile.slug} onSelect={onBrandChange} />)}
        </div>}
      </>}
    </div>
  );
}
